import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

import mouseIcon from "../../images/Icons/mouseIcon.svg";
import greenArrowIcon from "../../images/Icons/greenArrowIcon.svg";
import Toy1 from "../../images/toy1.png";
import Toy2 from "../../images/toy2.png";
import CircleOrange from "../../images/circleOrange.svg";
import CircleYellow from "../../images/circleYellow.svg";
import Waves from "../../images/waves.png";
import Shapes from "../../images/shapes.png";
import howWorksFundo from "../../images/howWorks-Fundo.png";
import howWorksImage from "../../images/howWorks-Image.png";
import SnailIcon from "../../images/Icons/snailIcon.svg";
import StarIcon from "../../images/Icons/starIcon.svg";
import IconDelivery from "../../images/Icons/iconDelivery.svg";
import IconEconomy from "../../images/Icons/iconEconomy.svg";
import IconToy from "../../images/Icons/iconToy.svg";
import iconCleaning from "../../images/Icons/iconCleaning.svg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

import "./home-page.scss";
import { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import { FranchiseContext } from "../../contexts/franchiseContext";
import { LoadingContext } from "../../contexts/loadingContext";
import { CartContext } from "../../contexts/cartContext";

function carousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 2 : 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };

  return (
    <Slider {...settings} className="slider">
      <div className="d-flex slider__item">
        <p className="slider__item__label">Diversão</p>
        <img src={SnailIcon} alt="Caracol" />
      </div>
      <div className="d-flex slider__item">
        <p className="slider__item__label">Alegria</p>
        <img src={StarIcon} alt="Estrela" />
      </div>
      <div className="d-flex slider__item">
        <p className="slider__item__label">Bem Estar</p>
        <img src={SnailIcon} alt="Caracol" />
      </div>
      <div className="d-flex slider__item">
        <p className="slider__item__label">Felicidade</p>
        <img src={StarIcon} alt="Estrela" />
      </div>
    </Slider>
  );
}

function HomePage() {
  const [franchises, setFranchises] = useState([]);
  const { setIsLoadingGlobal } = useContext(LoadingContext);
  const { setFranchise } = useContext(FranchiseContext);

  const { removeAllCartItems } = useContext(CartContext);

  const getFranchises = async () => {
    setIsLoadingGlobal(true);
    api
      .get("franchises")
      .then((response) => {
        setFranchises(response.data);
        setIsLoadingGlobal(false);
      })
      .catch(() => setIsLoadingGlobal(false));
  };

  useEffect(() => {
    getFranchises();
    removeAllCartItems();
  }, []);

  return (
    <div className="d-flex flex-column justify-content-center home-page">
      <section className="d-flex flex-column justify-content-center align-items-center home">
        <div className="home-content">
          <h1 className="home-title">
            Um novo jeito de <br /> brincar sem acumular!
          </h1>
          <p className="mt-3 home-subtitle">
            Ensine seu filho a se divertir de forma consciente com os mais
            diversos produtos da Adoleta.
          </p>
          <div className="select-box mt-5">
            <p className="mb-2">Comece selecionando uma imagem</p>
            <div className="d-flex city-select p-3">
              <select
                className="form-select border-0 cities"
                aria-label="Default select example"
                onChange={(e) => {
                  const franchiseFound = franchises.find(
                    (f) => f.id == e.target.value
                  );
                  localStorage.setItem(
                    "franchise",
                    JSON.stringify(franchiseFound)
                  );
                  setFranchise(franchiseFound);
                }}
                defaultValue={0}
              >
                <option value="0">Selecione uma cidade</option>
                {franchises.map((franchise) => (
                  <option key={franchise.id} value={franchise.id}>{franchise.name}</option>
                ))}
              </select>
              <Link
                to={"/brinquedos-adoleta"}
                style={{ textDecoration: "none" }}
              >
                <button type="button" className="btn ms-2 see-toys">
                  VER BRINQUEDOS
                </button>
              </Link>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between gap-5 mt-5 fast-direct">
            <div className="d-flex gap-2">
              <Link href="#">COMO FUNCIONA</Link>
              <img src={greenArrowIcon} alt="Setinha" />
            </div>
            <div className="d-flex gap-2">
              <Link href="#">VANTAGENS</Link>
              <img src={greenArrowIcon} alt="Setinha" />
            </div>
          </div>
          <div className="teste text-center mt-5">
            <img src={mouseIcon} width={80} height={80} alt="Mouse icone" />
          </div>
        </div>
      </section>
      <section className="container-fluid benefits">
        {carousel()}
        <div className="row benefits-texts">
          <div className={`col leftToys`}>
            <div className="container">
              <img src={CircleYellow} alt="Círculo amarelo" />
              <img src={Toy1} className="img-fluid" alt="Brinquedo 1" />
            </div>
          </div>
          <div
            className={`${
              isMobile ? "" : "col-6"
            } container d-flex flex-column align-items-center align-self-center justify-content-center text-center texts`}
          >
            <img src={Shapes} className="img-fluid" alt="Formas" />
            <p className={isMobile ? "fz-16" : ""}>
              economize, incentive, alugue!
            </p>
            <h1 className={isMobile ? "fz-35" : ""}>
              Queremos fazer parte de cada fase da vida do seu filho.
            </h1>
            <h4 className={isMobile ? "fz-16" : ""}>
              Precisa de diversão que estimule e desenvolva os pequenos? Adoleta
              é a solução! Além de economizar, você estará educando o seu filho
              a contribuir para um planeta mais sustentável. Aqui nós temos uma
              enorme variedade de brinquedos à disposição para alegrar ainda
              mais o dia a dia do seu bebê.
            </h4>
            <img src={Waves} className="img-fluid" alt="Ondinhas" />
          </div>
          <div className="col rigthToys">
            <div className="container">
              <img
                src={CircleOrange}
                className="img-fluid"
                alt="Círculo laranja"
                width={100}
                height={100}
              />
              <img src={Toy2} className="img-fluid" alt="Brinquedo 2" />
            </div>
          </div>
        </div>
      </section>
      <section className="container-fluid how-works">
        <div
          className={`container-fluid ${
            isMobile ? "text-center" : "row justify-items-center"
          } content`}
        >
          <div className={`${isMobile ? "" : "col-7"} text-start`}>
            <div className="row title">
              <h3>COMO FUNCIONA O PASSO A PASSO?</h3>
              <h1>É simples e prático!</h1>
              <p className="mt-4">
                Preparamos uma lista completa com os melhores brinquedos que
                irão somar ainda mais na vida e nos momentos de lazer dos
                pequeninos, ajudando a descobrir novas maneiras de estimular o
                desenvolvimento motor, cognitivo e sensorial do seu bebê. Mas,
                para que isso aconteça, será necessário realizar as seguintes
                etapas:
              </p>
            </div>
            <div className="row mt-5 steps">
              <div className="d-flex">
                <div>
                  <div className="number number-1 me-2 rounded-circle">1</div>
                </div>
                <div className="texts mt-2 d-flex align-items-center">
                  <div>
                    <h1>Faça login e escolha o melhor para o seu filho</h1>
                    <p>
                      Chegou a hora de partir para a ação! Após entrar no nosso
                      site, clique na loja mais próxima de você, cadastre-se e
                      pesquise o brinquedo perfeito conforme a faixa etária da
                      criança.
                    </p>
                  </div>
                  {isMobile ? (
                    ""
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40px"
                      height="40px"
                      fill="currentColor"
                      className="bi bi-arrow-right ms-3"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <div className="how-works__divider"></div>
              <div className="d-flex">
                <div>
                  <div className="number number-2 me-2 rounded-circle">2</div>
                </div>
                <div className="texts mt-1 d-flex align-items-center">
                  <div>
                    <h1>Selecione o produto desejado</h1>
                    <p>
                      Já escolheu o novo entretenimento do seu neném? Pois bem!
                      Agora coloque-o no carrinho e selecione a melhor forma de
                      pagamento. O período da locação é de 30 dias, porém, se
                      seu pimpolho gostar muito do brinquedo, você poderá
                      renová-lo por mais tempo.
                    </p>
                  </div>
                  {isMobile ? (
                    ""
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40px"
                      height="40px"
                      fill="currentColor"
                      className="bi bi-arrow-right ms-3"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <div className="how-works__divider"></div>
              <div className="d-flex">
                <div>
                  <div className="number number-3 me-2 rounded-circle">3</div>
                </div>
                <div className="texts mt-1 d-flex align-items-center">
                  <div>
                    <h1>Pronto, agora é só esperar!</h1>
                    <p>
                      O brinquedo irá chegar na sua casa todo embalado e
                      higienizado, após 3 dias úteis da confirmação do
                      pagamento. Contudo, se preferir, você pode fazer a
                      retirada no local e ainda ganha 10% de desconto. Vamos lá?
                    </p>
                  </div>
                  {isMobile ? (
                    ""
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40px"
                      height="40px"
                      fill="currentColor"
                      className="bi bi-arrow-right ms-3"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <div className="how-works__divider"></div>
            </div>
          </div>
          <div className={`${isMobile ? "margins" : "col text-end"} images`}>
            <img
              src={howWorksFundo}
              className="img-fluid background"
              style={
                isMobile ? { position: "relative" } : { position: "absolute" }
              }
              alt="Fundo"
            />
            <img src={howWorksImage} className="img-fluid image" alt="Imagem" />
          </div>
        </div>
      </section>
      <section className="container-fluid text-center advantages">
        <div className="container-fluid content">
          <div
            className="row d-flex justify-content-center title"
            style={isMobile ? { margin: "auto 5px" } : { margin: "0" }}
          >
            <h4 style={isMobile ? { fontSize: "16px" } : { fontSize: "18px" }}>
              Cuidamos de cada detalhe do início ao fim
            </h4>
            <h1 style={isMobile ? { fontSize: "32px" } : { fontSize: "48px" }}>
              Por que locar com a Adoleta?
            </h1>
            <p>
              Porque prezamos pela felicidade do seu bebê - apoiando o consumo
              consciente, evitando o desperdício de brinquedos, incentivando a
              sustentabilidade e plantando a sementinha da empatia - tudo para
              deixar a infância do seu filho ainda mais especial. Conheça alguns
              dos benefícios:
            </p>
          </div>
          <div className={`row justify-content-center options`}>
            <div
              className="col option"
              style={isMobile ? { maxWidth: "none" } : { maxWidth: "312px" }}
            >
              <span>
                <img
                  src={IconEconomy}
                  width={80}
                  height={80}
                  alt="Icone economia"
                />
              </span>
              <div className="texts">
                <h1>Mais diversão e menos desperdício</h1>
                <p>
                  Chega de tropeçar em muitos brinquedos! Quantidade não é
                  qualidade. Economize alugando apenas o que irá estimular o seu
                  pimpolho em cada fase do seu crescimento e evite o acúmulo na
                  sua casa.
                </p>
              </div>
            </div>
            <div
              className="col option"
              style={isMobile ? { maxWidth: "none" } : { maxWidth: "312px" }}
            >
              <span>
                <img
                  src={IconDelivery}
                  width={80}
                  height={80}
                  alt="Icone entrega"
                />
              </span>
              <div className="texts">
                <h1>Conforto e brinquedos de qualidade</h1>
                <p>
                  Alugue e fique tranquilo, aqui a diversão do seu filho é
                  garantida! Além de poder trocar o brinquedo de acordo com o
                  seu desenvolvimento, você ainda o recebe na comodidade do seu
                  lar sem se preocupar.
                </p>
              </div>
            </div>
            <div
              className="col option"
              style={isMobile ? { maxWidth: "none" } : { maxWidth: "312px" }}
            >
              <span>
                <img
                  src={iconCleaning}
                  width={80}
                  height={80}
                  alt="Icone limpeza"
                />
              </span>
              <div className="texts">
                <h1>Cuidamos de toda higienização</h1>
                <p>
                  O bem-estar dos pequenos em primeiro lugar! Nossos produtos
                  são totalmente higienizados e conservados para que a
                  experiência com o brinquedinho seja sempre mais prazerosa.
                </p>
              </div>
            </div>
            <div
              className="col option"
              style={isMobile ? { maxWidth: "none" } : { maxWidth: "312px" }}
            >
              <span>
                <img
                  src={IconToy}
                  width={80}
                  height={80}
                  alt="Icone brinquedo"
                />
              </span>
              <div className="texts">
                <h1>Grandes variedades de brinquedos</h1>
                <p>
                  Tenha sempre uma novidade em casa! Alterne as brincadeiras
                  infantis e ajude a desenvolver a criatividade do seu filho de
                  forma independente, incentivando-o ao desapego material.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
